











import Vue from 'vue';

import FilePicker from '@/utils/FilePicker';

export default Vue.extend({
    methods: {
        async importColors() {
            const data = await FilePicker.upload({ accept: 'application/javascript' });
            const module: any = {};

            eval(data);

            const customColors = module.exports?.theme?.colors;
            const extendedColors = module.exports?.theme?.extend?.colors;

            if (customColors) {
                this.$emit('updateColors', this.parseColors(customColors));

                return;
            }

            // TODO generate extended colors in exported config.
            if (extendedColors) {
                this.$emit('updateColors', this.parseColors(extendedColors));

                return;
            }

            this.$emit('updateColors', []);
        },
        parseColors(colors: any): ColorDefinition[] {
            const definitions: ColorDefinition[] = [];

            for (const [name, shades] of Object.entries(colors)) {
                if (typeof shades !== 'object') {
                    definitions.push({
                        name,
                        shades: {
                            default: shades as any,
                        },
                    });

                    continue;
                }

                definitions.push({
                    name,
                    shades: shades as any,
                });
            }

            return definitions;
        },
    },
});
